import { useQuery } from "@tanstack/react-query"
import { apiGET } from "data/api/get"

/**
 * Returns a list of metrics.
 * e.g. https://api.tokenterminal.com/v3/internal/lists/metrics
 * @example
 * const { data: metricsList } = useMetricsList()
 */

export const useMetricsList = () => {
  return useQuery({
    queryKey: ["metrics-list"],
    queryFn: async () => {
      const result = await apiGET("/v3/internal/lists/metrics")
      return result.data
    },
    staleTime: 1000 * 60 * 10,
  })
}
